<script>
  import { onMount } from 'svelte'

  // ローディングインジケータを隠す
  onMount(() => {
    document.querySelector('[data-id="appLoader"]').remove()
  })
</script>
